import { brand } from './colors';
import { fontFamily } from './fontFamily';
export const styles = {
    global: {
        body: {
            '--chakra-colors-chakra-body-text': brand.white,
            '--chakra-colors-chakra-body-bg': brand.black,
            fontSize: '16px',
            fontFamily: fontFamily.default,
        },
        'd1,d2,h1,h2,h3': {
            fontFamily: `${fontFamily.heading}`,
        },
        // no scrollbar
        '.no-scrollbar::-webkit-scrollbar': {
            display: 'none',
        },
        '.no-scrollbar': {
            scrollbarWidth: 'none',
        },
    },
};
